import Vue from 'vue';
import RepresentativeFinder from '@components/Representatives/RepresentativeFinder';

Vue.config.productionTip = false;
Vue.prototype.$http = window.axios;

const repApp = new Vue({
  el: '#rep-mount',

  components: {
    RepresentativeFinder,
  },
});
